module.exports = __webpack_public_path__ + "static/007181-6c290a97cce8967074d4103c8e8eb728.jpg";